/**
 * @owner @Appboy/frontend-ix
 */

export const cacheKey = "/dust/auth/:app_group_id";
